(function () {
  'use strict';

  var $ = function(sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); };

  var root = $('.esp02');
  if (!root) return;

  var PREFIJO_SKU = root.dataset.prefijoSku || 'ESP_02';
  var WA_NUMERO = root.dataset.whatsappNumero;
  var PRODUCT_TITLE = $('.esp02__titulo').textContent.trim();

  var state = {
    variantes: [],
    seleccion: {
      alto: null,
      ancho: null,
      fondo: null,
      niveles: null,
      ensamble: 'Soldada',
      modulo: 'No',
      tendido: 'galvanizada'
    },
    cantidad: 1
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    state.variantes = window.ESP02_VARIANTES || [];
    bindEventos();
    seleccionPorDefecto();
    actualizar();
  }

  function buscarVariante(ref) {
    for (var i = 0; i < state.variantes.length; i++) {
      if (state.variantes[i].sku === ref) {
        return state.variantes[i];
      }
    }
    return null;
  }

 function getPrecio(variante) {
    var p = variante.price;
    if (typeof p === 'string') p = parseFloat(p);
    return p / 100;
  }

  function bindEventos() {
    // Click en cualquier pill (alto, ancho, fondo, niveles, ensamble, modulo)
    root.addEventListener('click', function(e) {
      var pill = e.target.closest('.esp02__pill');
      if (pill && !pill.classList.contains('is-disabled')) {
        var dim = pill.dataset.dim;
        var valor = pill.dataset.valor;
        if (['alto', 'ancho', 'fondo', 'niveles'].indexOf(dim) !== -1) {
          state.seleccion[dim] = parseInt(valor, 10);
        } else {
          state.seleccion[dim] = valor;
        }
        actualizar();
      }
    });

    // Radios de tendido
    $$('input[name="esp02_tendido"]').forEach(function(r) {
      r.addEventListener('change', function(e) {
        state.seleccion.tendido = e.target.value;
        actualizar();
      });
    });

    // Botones cantidad
    $$('.esp02__cantidad-btn').forEach(function(b) {
      b.addEventListener('click', function(e) {
        var input = $('#esp02-cantidad');
        var v = parseInt(input.value, 10) || 1;
        v += (e.target.dataset.action === 'mas' ? 1 : -1);
        v = Math.max(1, Math.min(99, v));
        input.value = v;
        state.cantidad = v;
        actualizar();
      });
    });

    $('#esp02-cantidad').addEventListener('change', function(e) {
      state.cantidad = Math.max(1, parseInt(e.target.value, 10) || 1);
      e.target.value = state.cantidad;
      actualizar();
    });

    // Thumbnails
    $$('.esp02__thumb').forEach(function(t) {
      t.addEventListener('click', function() {
        $$('.esp02__thumb').forEach(function(x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        $('#esp02-render').src = t.dataset.image;
      });
    });

    $('#esp02-comprar').addEventListener('click', onComprarClick);
    $('#esp02-asesor').addEventListener('click', onAsesorClick);
  }

  function seleccionPorDefecto() {
    // FORZADO: arrancar SIEMPRE en ESP_02_240_240_60_3 (variante con precio: $1.899.053)
    state.seleccion.alto = 240;
    state.seleccion.ancho = 240;
    state.seleccion.fondo = 60;
    state.seleccion.niveles = 3;
    state.seleccion.ensamble = 'Soldada';
    state.seleccion.modulo = 'No';
    state.seleccion.tendido = 'galvanizada';
    console.log('[MAIKO ESP-02] Seleccion forzada: 240/240/60/3 - galvanizada - sin modulo');
  }

  // Regla central: forzar WhatsApp
  function requiereCotizacion() {
    return state.seleccion.modulo === 'Si' || state.seleccion.tendido === 'sin_lamina';
  }

  function actualizar() {
    // Marcar pills activos
    ['alto', 'ancho', 'fondo', 'niveles', 'ensamble', 'modulo'].forEach(function(dim) {
      $$('.esp02__pill[data-dim="' + dim + '"]').forEach(function(p) {
        var valor = p.dataset.valor;
        var esNumerico = ['alto', 'ancho', 'fondo', 'niveles'].indexOf(dim) !== -1;
        var match = esNumerico ? parseInt(valor, 10) === state.seleccion[dim] : valor === state.seleccion[dim];
        p.classList.toggle('is-active', match);
      });
    });

    var ref = construirRef();
    $('#esp02-ref').textContent = ref;

    if (requiereCotizacion()) {
      modoCotizar();
    } else {
      var variante = buscarVariante(ref);
      if (variante) {
        modoComprar(variante);
      } else {
        modoCotizar();
      }
    }

    actualizarCargaTotal();
    cambiarImagenPorNiveles(state.seleccion.niveles);
  }

  function cambiarImagenPorNiveles(niveles) {
    var container = document.getElementById('esp02-niveles-images');
    if (!container) return;
    var fondo = state.seleccion.fondo;
    var renderEl = document.getElementById('esp02-render');

    // 1. Match exacto: niveles-N-fondo-X
    var imgExacto = container.querySelector('img[data-niveles="niveles-' + niveles + '-fondo-' + fondo + '"]');
    if (imgExacto) {
      renderEl.src = imgExacto.src;
      return;
    }

    // 2. Respetando los NIVELES seleccionados, buscar cualquier profundidad disponible
    //    Orden de preferencia: 100 (mas visual) -> 60 -> 120 -> cualquiera
    var profundidadesPreferidas = [100, 60, 120, 80, 30, 50];
    for (var i = 0; i < profundidadesPreferidas.length; i++) {
      var imgAlt = 'niveles-' + niveles + '-fondo-' + profundidadesPreferidas[i];
      var img = container.querySelector('img[data-niveles="' + imgAlt + '"]');
      if (img) {
        renderEl.src = img.src;
        return;
      }
    }

    // 3. Fallback: buscar cualquier imagen con esos niveles (regex)
    var todasImagenes = container.querySelectorAll('img[data-niveles]');
    for (var j = 0; j < todasImagenes.length; j++) {
      var alt = todasImagenes[j].getAttribute('data-niveles');
      if (alt && alt.indexOf('niveles-' + niveles) === 0) {
        renderEl.src = todasImagenes[j].src;
        return;
      }
    }

    // 4. Ultimo fallback: alt exacto "niveles-N" (compatibilidad con sistema viejo)
    var imgNiveles = container.querySelector('img[data-niveles="niveles-' + niveles + '"]');
    if (imgNiveles) {
      renderEl.src = imgNiveles.src;
      return;
    }

    // 5. Si nada funciona, primera imagen disponible
    var primera = container.querySelector('img[data-niveles]');
    if (primera) {
      renderEl.src = primera.src;
    }
  }

  function construirRef() {
    var s = state.seleccion;
    return PREFIJO_SKU + '_' + s.alto + '_' + s.ancho + '_' + s.fondo + '_' + s.niveles;
  }

  function actualizarCargaTotal() {
    var cargaPorNivel = parseInt($('#esp02-carga-nivel').textContent, 10) || 0;
    if (cargaPorNivel > 0) {
      $('#esp02-carga-total').textContent = (cargaPorNivel * state.seleccion.niveles) + ' kg';
    }
  }

  function modoComprar(variante) {
    var precio = getPrecio(variante);
    var total = precio * state.cantidad;
    $('#esp02-precio').textContent = formatearPrecio(total);
    $('#esp02-precio').classList.remove('is-cotizar');
    $('.esp02__precio-iva').style.display = '';
    $('#esp02-mensaje-cotizar').hidden = true;
    $('#esp02-cantidad-wrapper').hidden = false;
    $('#esp02-comprar-texto').textContent = $('#esp02-comprar-texto').getAttribute('data-default') || 'Comprar';
    $('#esp02-comprar').classList.remove('esp02__btn--cotizar');
    $('#esp02-comprar').disabled = false;
  }

  function modoCotizar() {
    $('#esp02-precio').textContent = 'Cotización personalizada';
    $('#esp02-precio').classList.add('is-cotizar');
    $('.esp02__precio-iva').style.display = 'none';
    $('#esp02-mensaje-cotizar').hidden = false;
    $('#esp02-cantidad-wrapper').hidden = true;
    $('#esp02-comprar-texto').textContent = 'Solicitar cotización';
    $('#esp02-comprar').classList.add('esp02__btn--cotizar');
    $('#esp02-comprar').disabled = false;
  }

  function onComprarClick() {
    if (requiereCotizacion()) {
      abrirWhatsApp(construirRef(), 'cotizacion');
      return;
    }
    var ref = construirRef();
    var variante = buscarVariante(ref);
    if (variante) {
      agregarAlCarrito(ref, variante);
    } else {
      abrirWhatsApp(ref, 'cotizacion');
    }
  }

  function onAsesorClick() {
    abrirWhatsApp(construirRef(), 'asesor');
  }

  function agregarAlCarrito(ref, variante) {
    var btn = $('#esp02-comprar');
    var textoOriginal = $('#esp02-comprar-texto').textContent;
    btn.disabled = true;
    $('#esp02-comprar-texto').textContent = 'Agregando...';
    var s = state.seleccion;
    var properties = {
      'Alto': s.alto + ' cm',
      'Ancho': s.ancho + ' cm',
      'Profundidad': s.fondo + ' cm',
      'Niveles': s.niveles,
      'Tipo de ensamble': s.ensamble,
      'Módulo adicional': s.modulo === 'Si' ? 'Sí' : 'No',
      'Tipo de tendido': s.tendido === 'galvanizada' ? 'Lámina galvanizada' : 'Sin lámina'
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variante.id, quantity: state.cantidad, properties: properties }]
      })
    })
    .then(function(resp) {
      if (!resp.ok) throw new Error('Error');
      window.location.href = '/cart';
    })
    .catch(function() {
      alert('No pudimos agregar el producto al carrito. Por favor intenta de nuevo o contáctanos por WhatsApp.');
      btn.disabled = false;
      $('#esp02-comprar-texto').textContent = textoOriginal;
    });
  }

  function abrirWhatsApp(ref, tipo) {
    var s = state.seleccion;
    var tendidoLabel = s.tendido === 'galvanizada' ? 'Lámina galvanizada' : 'Sin lámina (solo perfil)';
    var moduloLabel = s.modulo === 'Si' ? 'Sí' : 'No';
    var variante = buscarVariante(ref);
    var mensaje;

    if (tipo === 'cotizacion') {
      mensaje = 'Hola Maiko, quiero cotizar una estantería personalizada:\n\n' +
                'Producto: ' + PRODUCT_TITLE + '\n' +
                'Referencia: ' + ref + '\n' +
                'Alto: ' + s.alto + ' cm\n' +
                'Ancho: ' + s.ancho + ' cm\n' +
                'Profundidad: ' + s.fondo + ' cm\n' +
                'Niveles: ' + s.niveles + '\n' +
                'Tipo de ensamble: ' + s.ensamble + '\n' +
                'Módulo adicional: ' + moduloLabel + '\n' +
                'Tendido: ' + tendidoLabel + '\n\n' +
                'Quedo atento a la cotización, gracias.';
    } else {
      var precioInfo = variante && !requiereCotizacion() ?
        '\nPrecio web: ' + formatearPrecio(getPrecio(variante)) :
        '\nCotización: personalizada';
      mensaje = 'Hola Maiko, quiero hablar con un asesor sobre:\n\n' +
                'Producto: ' + PRODUCT_TITLE + '\n' +
                'Referencia: ' + ref + '\n' +
                s.alto + 'x' + s.ancho + 'x' + s.fondo + ' cm - ' + s.niveles + ' niveles\n' +
                'Ensamble: ' + s.ensamble + '\n' +
                'Módulo adicional: ' + moduloLabel + '\n' +
                'Tendido: ' + tendidoLabel + precioInfo;
    }
    window.open('https://wa.me/' + WA_NUMERO + '?text=' + encodeURIComponent(mensaje), '_blank', 'noopener');
  }

  function formatearPrecio(valor) {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(valor);
  }

})();
